document.addEventListener("DOMContentLoaded", function () {
  const fc = document.querySelector(".fc");
  const triggerBtn = document.querySelector(".fc__trigger");
  const panel = document.querySelector(".fc__panel");
  const closeBtn = document.querySelector(".fc__close");

  if (!fc || !triggerBtn || !panel) return;

  /* ======================
     開閉処理
  ====================== */

  // 開く
  triggerBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    fc.classList.add("is-open");
  });

  // 閉じるボタン
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      fc.classList.remove("is-open");
    });
  }

  // 外側クリックで閉じる
  document.addEventListener("click", function (e) {
    if (
      fc.classList.contains("is-open") &&
      !panel.contains(e.target) &&
      !triggerBtn.contains(e.target)
    ) {
      fc.classList.remove("is-open");
    }
  });

  /* ======================
     スクロールで表示制御
  ====================== */

  const scrollTrigger = document.querySelector(".js-fixed-cart-trigger");
  if (!scrollTrigger) return;

  const triggerBottom =
    scrollTrigger.getBoundingClientRect().bottom + window.pageYOffset;

  window.addEventListener("scroll", () => {
    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > triggerBottom) {
      fc.classList.add("is-visible");
    } else {
      fc.classList.remove("is-visible");
      fc.classList.remove("is-open"); // 上に戻ったらパネルも閉じる
    }
  });
});